<template>
	<div class="poresurvey">
		<Loading msg="loading" v-if="!isload" />
		<div class="pore_survey_inner" v-else>
      <div class="survey_entry" v-if="!show_survey">
      		<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <h1 class="pore_survey_title">拯救毛孔粗大</h1>
                <div class="pore_qa">
                    <div class="pore_qa_title">关于毛孔的快速回答</div>
                    <div class="pore_qa_2nd_title">毛孔是什么?</div>
                    <p class="pore_qa_info">毛孔是毛囊的开口，是毛发生成的地方，也是皮脂排出的地方</p>
                    <div class="pore_qa_2nd_title">毛孔粗大的原因有哪些?</div>
                    <p class="pore_qa_info">出油过多，毛孔堵塞、被撑大；<br>皮肤衰老松弛，毛孔扩大；<br>由于各种原因引发的炎症，例如痘痘、脂溢性皮炎等，使毛囊区域形成疤痕，显得坑坑洼洼</p>
                </div>
                <p class="qa_sub_text">填写一份2分钟的小问卷，UNISKIN将会结合您的基因、现状数据，为您提供个性化的毛孔问题解决方案</p>
                <div class="pore_start_btn" @click="(show_survey=true);($parent.trackLog((actParams = { query: $route.query, pageid:493 }),{is_access:true,reportEvent_page_id:493,reportEvent_page_name:'毛孔-开启问卷',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'}))">开启问卷</div>
                
        </div>

        <!-- 问卷区域 -->
        <div class="survey_container" v-else>

        <!-- 无表型结果  新增问卷q1 -->
          <div class="survey_container_no_pheno" v-if="!has_pheno">
              <!-- 第一题 -->
              <div class="survey_1 survey_item" v-if="(survey_index == 1)">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_1">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                
                  <div class="detail_title">选择你的出油区域</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="checkbox" id="survey_1_a" value="A" v-model="form_obj.skinquestion1" :disabled="(form_obj.skinquestion1.indexOf('C') > -1)" :checked="(form_obj.skinquestion1.indexOf('C') > -1)">
                      <label for="survey_1_a" :class="(form_obj.skinquestion1.indexOf('C') > -1) ? 'gray' : (form_obj.skinquestion1.indexOf('A') > -1) ? 'now' : ''">T区</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_1_b" value="B" v-model="form_obj.skinquestion1" :disabled="(form_obj.skinquestion1.indexOf('C') > -1)" :checked="(form_obj.skinquestion1.indexOf('C') > -1)">
                      <label for="survey_1_b" :class="(form_obj.skinquestion1.indexOf('C') > -1) ? 'gray' : (form_obj.skinquestion1.indexOf('B') > -1) ? 'now' : ''">脸颊</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_1_c" value="C" >
                      <label for="survey_1_c" :class="(form_obj.skinquestion1.indexOf('C') > -1) ? 'now' : ''" @click="changeinput_ques1()">不出油</label>
                    </li>
                  </ul>
                </div>
                <div class="switch_page">
                  <!-- <div class="page_prev"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div> -->
                  <div class="page_next" @click="((form_obj.skinquestion1.length > 0) && (form_obj.skinquestion1.includes('A') && form_obj.skinquestion1.includes('B') || form_obj.skinquestion1.includes('C')) ? (current_ques++,survey_index=survey_index+2,getTotalQues()) : ((form_obj.skinquestion1.length > 0)&& (current_ques++,survey_index =survey_index+1,getTotalQues())))"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>
              <!-- 第二题 -->
              <div class="survey_2 survey_item"  v-if="(survey_index == 2)">
                  <div class="survey_item_title">拯救毛孔粗大</div>
                  <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                  <div class="survey_detail survey_detail_2">
                    <div class="pagination">
                      <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                      <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                    </div>
                    
                    <div class="detail_title">点击你毛孔粗大的区域(可多选)</div>
                    <ul class="detail_options">
                      <li class="option_item">
                        <input type="checkbox" id="survey_2_a" value="A" v-model="form_obj.skinquestion2">
                        <label for="survey_2_a" :class="(form_obj.skinquestion2.indexOf('A') > -1) ? 'now' : ''">T区</label>
                      </li>
                      <li class="option_item">
                        <input type="checkbox" id="survey_2_b" value="B" v-model="form_obj.skinquestion2">
                        <label for="survey_2_b" :class="(form_obj.skinquestion2.indexOf('B') > -1) ? 'now' : ''">脸颊</label>
                      </li>

                    </ul>
                  </div>
                  <div class="switch_page">
                    <div class="page_prev" @click="(current_ques--) && (survey_index =survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                    <div class="page_next" @click="(form_obj.skinquestion2.length > 0) && (form_obj.skinquestion2.includes('A') && form_obj.skinquestion2.includes('B') ? (current_ques++,survey_index = survey_index+3,getTotalQues()) : (current_ques++,survey_index = survey_index+1,getTotalQues()))"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                  </div>
              </div>
              <!-- 第三题   不需要区分 3 4 8 9题-->
              <div class="survey_3 survey_item"  v-if="(survey_index == 3)">
                  <div class="survey_item_title">拯救毛孔粗大</div>
                  <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                  <div class="survey_detail survey_detail_3">
                    <div class="pagination">
                      <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                       <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                      </div>
                   
                    <div class="detail_title">你的毛孔更接近以下哪一级程度</div>
                    <ul class="detail_options">
                      <li class="option_item">
                        <input type="radio" id="survey_3_a" value="A" v-model="form_obj.skinquestion3">
                        <label for="survey_3_a" :class="form_obj.skinquestion3 == 'A' ? 'now' : ''"><span>3级-清晰可见毛孔</span> <img src="../assets/images/pore_survey_1.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_3_b" value="B" v-model="form_obj.skinquestion3">
                        <label for="survey_3_b" :class="form_obj.skinquestion3 == 'B' ? 'now' : ''"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span><img src="../assets/images/pore_survey_2.png" alt=""></label>
                        
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_3_c" value="C" v-model="form_obj.skinquestion3">
                        <label for="survey_3_c" :class="form_obj.skinquestion3 == 'C' ? 'now' : ''"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span><img src="../assets/images/pore_survey_3.png" alt=""></label>
                        
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_3_d" value="D" v-model="form_obj.skinquestion3">
                        <label for="survey_3_d" :class="form_obj.skinquestion3 == 'D' ? 'now' : ''"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span><img src="../assets/images/pore_survey_4.png" alt=""></label>
                        
                      </li>

                    </ul>
                  </div>
                  <div class="switch_page">
                    <div class="page_prev" @click="(current_ques--) && (form_obj.skinquestion1.includes('A') && form_obj.skinquestion1.includes('B') || form_obj.skinquestion1.includes('C')) ? (survey_index=survey_index-2) : (survey_index =survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                    <div class="page_next" @click="(form_obj.skinquestion3.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                  </div>
              </div>
              <!-- 第四题 -->
              <div class="survey_4 survey_item"  v-if="survey_index == 4">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_4">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                  
                  <div class="detail_title">你的皮肤是否有以下<strong>任何一种</strong>情况<br>皮肤纹理粗糙<br>浅表色斑<br>静态纹</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="radio" id="survey_4_a" value="A" v-model="form_obj.skinquestion4">
                      <label for="survey_4_a" :class="form_obj.skinquestion4 == 'A' ? 'now' : ''">是</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_4_b" value="B" v-model="form_obj.skinquestion4">
                      <label for="survey_4_b" :class="form_obj.skinquestion4 == 'B' ? 'now' : ''">否</label>
                    </li>
                    <!-- <li class="option_item">
                      <input type="radio" id="survey_4_c" value="C" v-model="form_obj.skinquestion4">
                      <label for="survey_4_c" :class="form_obj.skinquestion4 == 'C' ? 'now' : ''">静态纹</label>
                    </li> -->
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(current_ques--) && (survey_index=survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion4.length > 0) && (current_ques++,survey_index=survey_index+3)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>
              <!-- 第五题 第六题  区分5 6 7 8 9-->
              <div class="survey_5 survey_item"  v-if="survey_index == 5">
                  <div class="survey_item_title">拯救毛孔粗大</div>
                  <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                  <div class="survey_detail survey_detail_5">
                    <div class="pagination">
                      <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                      <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                    </div>
                    
                    <div class="detail_title">你的毛孔更接近以下哪一级程度</div>
                    <div class="detail_2nd_title">(额头区域必选一，脸颊区域必选一)</div>
                    <ul class="detail_options detail_options_5">
                      <li class="option_item">
                        <input type="radio" id="survey_5_a" value="A" v-model="form_obj.skinquestion5">
                        <label for="survey_5_a" :class="form_obj.skinquestion5 == 'A' ? 'now' : ''"><span>3级-清晰可见毛孔</span><img src="../assets/images/pore_survey_1.png" alt=""></label>
                        
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_b" value="B" v-model="form_obj.skinquestion5">
                        <label for="survey_5_b" :class="form_obj.skinquestion5 == 'B' ? 'now' : ''"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span> <img src="../assets/images/pore_survey_2.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_c" value="C" v-model="form_obj.skinquestion5">
                        <label for="survey_5_c" :class="form_obj.skinquestion5 == 'C' ? 'now' : ''"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span> <img src="../assets/images/pore_survey_3.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_d" value="D" v-model="form_obj.skinquestion5">
                        <label for="survey_5_d" :class="form_obj.skinquestion5 == 'D' ? 'now' : ''"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span> <img src="../assets/images/pore_survey_4.png" alt=""></label>
                      
                      </li>

                    </ul>
                    <ul class="detail_options detail_options_5_1">
                      <li class="option_item">
                        <input type="radio" id="survey_5_1_a" value="A" v-model="form_obj.skinquestion6">
                        <label for="survey_5_1_a" :class="form_obj.skinquestion6 == 'A' ? 'now' : ''"><span>3级-清晰可见毛孔</span> <img src="../assets/images/pore_survey_1.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_1_b" value="B" v-model="form_obj.skinquestion6">
                        <label for="survey_5_1_b" :class="form_obj.skinquestion6 == 'B' ? 'now' : ''"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span> <img src="../assets/images/pore_survey_2.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_1_c" value="C" v-model="form_obj.skinquestion6">
                        <label for="survey_5_1_c" :class="form_obj.skinquestion6 == 'C' ? 'now' : ''"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span> <img src="../assets/images/pore_survey_3.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_1_d" value="D" v-model="form_obj.skinquestion6">
                        <label for="survey_5_1_d" :class="form_obj.skinquestion6 == 'D' ? 'now' : ''"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span> <img src="../assets/images/pore_survey_4.png" alt=""></label>
                      
                      </li>

                    </ul>
                  </div>
                  <div class="switch_page">
                    <div class="page_prev" @click="(current_ques--) && (survey_index=survey_index-3)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                    <div class="page_next" @click="(form_obj.skinquestion5.length > 0) && (form_obj.skinquestion6.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                  </div>
              </div>

              <!-- 第7题   不需要区分  6-8题-->
              <div class="survey_6 survey_item"  v-if="survey_index == 6">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_6">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                  
                  <div class="detail_title">你的皮肤是否有以下<strong>任何一种</strong>情况<br>皮肤纹理粗糙<br>浅表色斑<br>静态纹</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="radio" id="survey_6_a" value="A" v-model="form_obj.skinquestion7">
                      <label for="survey_6_a" :class="form_obj.skinquestion7 == 'A' ? 'now' : ''">额头有</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_6_b" value="B" v-model="form_obj.skinquestion7">
                      <label for="survey_6_b" :class="form_obj.skinquestion7 == 'B' ? 'now' : ''">脸颊有</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_6_c" value="C" v-model="form_obj.skinquestion7">
                      <label for="survey_6_c" :class="form_obj.skinquestion7 == 'C' ? 'now' : ''">额头和脸颊都有</label>
                    </li>
                      <li class="option_item">
                      <input type="radio" id="survey_6_d" value="D" v-model="form_obj.skinquestion7">
                      <label for="survey_6_d" :class="form_obj.skinquestion7 == 'D' ? 'now' : ''">都没有</label>
                    </li>
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(current_ques--) && (survey_index = survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion7.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>

              <!-- 第8题 -->
              <div class="survey_7 survey_item"  v-if="survey_index == 7">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_7">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                     <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                 
                  <div class="detail_title">你是否面部毛发较重</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="radio" id="survey_7_a" value="A" v-model="form_obj.skinquestion8">
                      <label for="survey_7_a" :class="form_obj.skinquestion8 == 'A' ? 'now' : ''">是</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_7_b" value="B" v-model="form_obj.skinquestion8">
                      <label for="survey_7_b" :class="form_obj.skinquestion8 == 'B' ? 'now' : ''">否</label>
                    </li>
                  
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(form_obj.skinquestion2.includes('A') && form_obj.skinquestion2.includes('B')) ? ((current_ques--) && (survey_index=survey_index-1)) : ((current_ques--) && (survey_index=survey_index-3))"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion8.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>

              <!-- 第9题 -->
              <div class="survey_8 survey_item"  v-if="survey_index == 8">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_8">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                  
                  <div class="detail_title">你是否有这些皮肤问题/皮肤病(可多选)</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_a" value="A" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_a" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' : (form_obj.skinquestion9.indexOf('A') > -1) ? 'now' : ''">严重痘痘</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_b" value="B" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_b" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' : (form_obj.skinquestion9.indexOf('B') > -1) ? 'now' : ''">面部红斑/潮红</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_c" value="C" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_c" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' : (form_obj.skinquestion9.indexOf('C') > -1) ? 'now' : ''">脂溢性皮炎</label>
                    </li>
                      <li class="option_item">
                      <input type="checkbox" id="survey_8_d" value="D" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_d" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' : (form_obj.skinquestion9.indexOf('D') > -1) ? 'now' : ''">皮炎/湿疹</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_e" value="E" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_e" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' : (form_obj.skinquestion9.indexOf('E') > -1) ? 'now' : ''">银屑病/牛皮癣</label>
                    </li>
                      <li class="option_item">
                      <input type="checkbox" id="survey_8_f" value="F">
                      <label for="survey_8_f" :class="(survey_9_selected) ? 'now' : ''" @click="changeinput()">都没有</label>
                    </li>
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(current_ques--) && (survey_index=survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion9.length > 0) && (show_survey_toaster=true)"><span>提交</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>
          </div>

          <!-- 存在表型问卷  待定   新增问卷  第二题-->
          <div class="survey_container_pheno_delay" v-if="has_pheno && (pheno_judge == 'delay')">
              <!-- 第二题 -->
              <div class="survey_2 survey_item"  v-if="(survey_index == 2)">
                  <div class="survey_item_title">拯救毛孔粗大</div>
                  <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                  <div class="survey_detail survey_detail_2">
                    <div class="pagination">
                      <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                      <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                    </div>
                    
                    <div class="detail_title">点击你毛孔粗大的区域(可多选)</div>
                    <ul class="detail_options">
                      <li class="option_item">
                        <input type="checkbox" id="survey_2_a" value="A" v-model="form_obj.skinquestion2">
                        <label for="survey_2_a" :class="(form_obj.skinquestion2.indexOf('A') > -1) ? 'now' : ''">T区</label>
                      </li>
                      <li class="option_item">
                        <input type="checkbox" id="survey_2_b" value="B" v-model="form_obj.skinquestion2">
                        <label for="survey_2_b" :class="(form_obj.skinquestion2.indexOf('B') > -1) ? 'now' : ''">脸颊</label>
                      </li>

                    </ul>
                  </div>
                  <div class="switch_page">
                    <!-- <div class="page_prev" @click="(current_ques--) && (form_obj.skinquestion1.includes('A') && form_obj.skinquestion1.includes('B') || form_obj.skinquestion1.includes('C')) ? (survey_index=survey_index-2) : (survey_index =survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div> -->
                    <div class="page_next" @click="(form_obj.skinquestion2.length > 0) && (form_obj.skinquestion2.includes('A') && form_obj.skinquestion2.includes('B') ? (current_ques++,survey_index = survey_index+3,getTotalQues()) : (current_ques++,survey_index = survey_index+1,getTotalQues()))"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                  </div>
              </div>
              <!-- 第三题   不需要区分 3 4 8 9题-->
              <div class="survey_3 survey_item"  v-if="(survey_index == 3)">
                  <div class="survey_item_title">拯救毛孔粗大</div>
                  <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                  <div class="survey_detail survey_detail_3">
                    <div class="pagination">
                      <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                      <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                    </div>
                    
                    <div class="detail_title">你的毛孔更接近以下哪一级程度</div>
                    <ul class="detail_options">
                      <li class="option_item">
                        <input type="radio" id="survey_3_a" value="A" v-model="form_obj.skinquestion3">
                        <label for="survey_3_a" :class="form_obj.skinquestion3 == 'A' ? 'now' : ''"><span>3级-清晰可见毛孔</span> <img src="../assets/images/pore_survey_1.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_3_b" value="B" v-model="form_obj.skinquestion3">
                        <label for="survey_3_b" :class="form_obj.skinquestion3 == 'B' ? 'now' : ''"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span><img src="../assets/images/pore_survey_2.png" alt=""></label>
                        
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_3_c" value="C" v-model="form_obj.skinquestion3">
                        <label for="survey_3_c" :class="form_obj.skinquestion3 == 'C' ? 'now' : ''"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span><img src="../assets/images/pore_survey_3.png" alt=""></label>
                        
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_3_d" value="D" v-model="form_obj.skinquestion3">
                        <label for="survey_3_d" :class="form_obj.skinquestion3 == 'D' ? 'now' : ''"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span><img src="../assets/images/pore_survey_4.png" alt=""></label>
                        
                      </li>

                    </ul>
                  </div>
                  <div class="switch_page">
                    <div class="page_prev" @click="(current_ques--) && (survey_index =survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                    <div class="page_next" @click="(form_obj.skinquestion3.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                  </div>
              </div>
              <!-- 第四题 -->
              <div class="survey_4 survey_item"  v-if="survey_index == 4">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_4">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                  
                  <div class="detail_title">你的皮肤是否有以下<strong>任何一种</strong>情况<br>皮肤纹理粗糙<br>浅表色斑<br>静态纹</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="radio" id="survey_4_a" value="A" v-model="form_obj.skinquestion4">
                      <label for="survey_4_a" :class="form_obj.skinquestion4 == 'A' ? 'now' : ''">是</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_4_b" value="B" v-model="form_obj.skinquestion4">
                      <label for="survey_4_b" :class="form_obj.skinquestion4 == 'B' ? 'now' : ''">否</label>
                    </li>
                    <!-- <li class="option_item">
                      <input type="radio" id="survey_4_c" value="C" v-model="form_obj.skinquestion4">
                      <label for="survey_4_c" :class="form_obj.skinquestion4 == 'C' ? 'now' : ''">静态纹</label>
                    </li> -->
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(current_ques--) && (survey_index=survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion4.length > 0) && (current_ques++,survey_index=survey_index+3)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>
              <!-- 第五 第六题   区分5 6 7 8 9-->
              <div class="survey_5 survey_item"  v-if="survey_index == 5">
                  <div class="survey_item_title">拯救毛孔粗大</div>
                  <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                  <div class="survey_detail survey_detail_5">
                    <div class="pagination">
                      <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                      <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                    </div>
                    
                    <div class="detail_title">你的毛孔更接近以下哪一级程度</div>
                    <div class="detail_2nd_title">(额头区域必选一，脸颊区域必选一)</div>
                    <ul class="detail_options detail_options_5">
                      <li class="option_item">
                        <input type="radio" id="survey_5_a" value="A" v-model="form_obj.skinquestion5">
                        <label for="survey_5_a" :class="form_obj.skinquestion5 == 'A' ? 'now' : ''"><span>3级-清晰可见毛孔</span><img src="../assets/images/pore_survey_1.png" alt=""></label>
                        
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_b" value="B" v-model="form_obj.skinquestion5">
                        <label for="survey_5_b" :class="form_obj.skinquestion5 == 'B' ? 'now' : ''"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span> <img src="../assets/images/pore_survey_2.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_c" value="C" v-model="form_obj.skinquestion5">
                        <label for="survey_5_c" :class="form_obj.skinquestion5 == 'C' ? 'now' : ''"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span> <img src="../assets/images/pore_survey_3.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_d" value="D" v-model="form_obj.skinquestion5">
                        <label for="survey_5_d" :class="form_obj.skinquestion5 == 'D' ? 'now' : ''"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span> <img src="../assets/images/pore_survey_4.png" alt=""></label>
                      
                      </li>

                    </ul>
                    <ul class="detail_options detail_options_5_1">
                      <li class="option_item">
                        <input type="radio" id="survey_5_1_a" value="A" v-model="form_obj.skinquestion6">
                        <label for="survey_5_1_a" :class="form_obj.skinquestion6 == 'A' ? 'now' : ''"><span>3级-清晰可见毛孔</span> <img src="../assets/images/pore_survey_1.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_1_b" value="B" v-model="form_obj.skinquestion6">
                        <label for="survey_5_1_b" :class="form_obj.skinquestion6 == 'B' ? 'now' : ''"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span> <img src="../assets/images/pore_survey_2.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_1_c" value="C" v-model="form_obj.skinquestion6">
                        <label for="survey_5_1_c" :class="form_obj.skinquestion6 == 'C' ? 'now' : ''"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span> <img src="../assets/images/pore_survey_3.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_5_1_d" value="D" v-model="form_obj.skinquestion6">
                        <label for="survey_5_1_d" :class="form_obj.skinquestion6 == 'D' ? 'now' : ''"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span> <img src="../assets/images/pore_survey_4.png" alt=""></label>
                      
                      </li>

                    </ul>
                  </div>
                  <div class="switch_page">
                    <div class="page_prev" @click="(current_ques--) && (survey_index=survey_index-3)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                    <div class="page_next" @click="(form_obj.skinquestion5.length > 0) && (form_obj.skinquestion6.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                  </div>
              </div>

              <!-- 第7题   -->
              <div class="survey_6 survey_item"  v-if="survey_index == 6">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_6">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                  
                  <div class="detail_title">你的皮肤是否有以下<strong>任何一种</strong>情况<br>皮肤纹理粗糙<br>浅表色斑<br>静态纹</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="radio" id="survey_6_a" value="A" v-model="form_obj.skinquestion7">
                      <label for="survey_6_a" :class="form_obj.skinquestion7 == 'A' ? 'now' : ''">额头有</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_6_b" value="B" v-model="form_obj.skinquestion7">
                      <label for="survey_6_b" :class="form_obj.skinquestion7 == 'B' ? 'now' : ''">脸颊有</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_6_c" value="C" v-model="form_obj.skinquestion7">
                      <label for="survey_6_c" :class="form_obj.skinquestion7 == 'C' ? 'now' : ''">额头和脸颊都有</label>
                    </li>
                      <li class="option_item">
                      <input type="radio" id="survey_6_d" value="D" v-model="form_obj.skinquestion7">
                      <label for="survey_6_d" :class="form_obj.skinquestion7 == 'D' ? 'now' : ''">都没有</label>
                    </li>
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(current_ques--) && (survey_index = survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion7.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>

              <!-- 第8题 -->
              <div class="survey_7 survey_item"  v-if="survey_index == 7">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_7">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                  
                  <div class="detail_title">你是否面部毛发较重</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="radio" id="survey_7_a" value="A" v-model="form_obj.skinquestion8">
                      <label for="survey_7_a" :class="form_obj.skinquestion8 == 'A' ? 'now' : ''">是</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_7_b" value="B" v-model="form_obj.skinquestion8">
                      <label for="survey_7_b" :class="form_obj.skinquestion8 == 'B' ? 'now' : ''">否</label>
                    </li>
                  
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(form_obj.skinquestion2.includes('A') && form_obj.skinquestion2.includes('B')) ? ((current_ques--) && (survey_index=survey_index-1)) : ((current_ques--) && (survey_index=survey_index-3))"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion8.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>

              <!-- 第9题 -->
              <div class="survey_8 survey_item"  v-if="survey_index == 8">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_8">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                  
                  <div class="detail_title">你是否有这些皮肤问题/皮肤病(可多选)</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_a" value="A" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_a" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('A') > -1) ? 'now' : ''">严重痘痘</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_b" value="B" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_b" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('B') > -1) ? 'now' : ''">面部红斑/潮红</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_c" value="C" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_c" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('C') > -1) ? 'now' : ''">脂溢性皮炎</label>
                    </li>
                      <li class="option_item">
                      <input type="checkbox" id="survey_8_d" value="D" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_d" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('D') > -1) ? 'now' : ''">皮炎/湿疹</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_e" value="E" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_e" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('E') > -1) ? 'now' : ''">银屑病/牛皮癣</label>
                    </li>
                      <li class="option_item">
                      <input type="checkbox" id="survey_8_f" value="F">
                      <label for="survey_8_f" :class="(survey_9_selected) ? 'now' : ''" @click="changeinput()">都没有</label>
                    </li>
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(current_ques--) && (survey_index=survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion9.length > 0) && (show_survey_toaster=true)"><span>提交</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>
          </div>


          <!-- 存在表型问卷  不区分  新增问卷  3-4-8-9 -->
          <div class="survey_container_pheno_nodelay" v-if="has_pheno && (pheno_judge == 'nodelay')">
              <!-- 第三题   不需要区分 3 4 8 9题-->
              <div class="survey_3 survey_item"  v-if="(survey_index == 3)">
                  <div class="survey_item_title">拯救毛孔粗大</div>
                  <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                  <div class="survey_detail survey_detail_3">
                    <div class="pagination">
                      <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                      <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                    </div>
                    
                    <div class="detail_title">你的毛孔更接近以下哪一级程度</div>
                    <ul class="detail_options">
                      <li class="option_item">
                        <input type="radio" id="survey_3_a" value="A" v-model="form_obj.skinquestion3">
                        <label for="survey_3_a" :class="form_obj.skinquestion3 == 'A' ? 'now' : ''"><span>3级-清晰可见毛孔</span> <img src="../assets/images/pore_survey_1.png" alt=""></label>
                      
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_3_b" value="B" v-model="form_obj.skinquestion3">
                        <label for="survey_3_b" :class="form_obj.skinquestion3 == 'B' ? 'now' : ''"><span>4级-明显可见毛孔，或内含小于毛孔大小的角栓</span><img src="../assets/images/pore_survey_2.png" alt=""></label>
                        
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_3_c" value="C" v-model="form_obj.skinquestion3">
                        <label for="survey_3_c" :class="form_obj.skinquestion3 == 'C' ? 'now' : ''"><span>5级-非常明显可见毛孔，或内含与毛孔大小一致的角栓</span><img src="../assets/images/pore_survey_3.png" alt=""></label>
                        
                      </li>
                      <li class="option_item">
                        <input type="radio" id="survey_3_d" value="D" v-model="form_obj.skinquestion3">
                        <label for="survey_3_d" :class="form_obj.skinquestion3 == 'D' ? 'now' : ''"><span>6级-明显扩大毛孔，或内含突出毛孔的角栓，呈草莓样</span><img src="../assets/images/pore_survey_4.png" alt=""></label>
                        
                      </li>

                    </ul>
                  </div>
                  <div class="switch_page">
                    <!-- <div class="page_prev" @click="(current_ques--) && (form_obj.skinquestion1.includes('A') && form_obj.skinquestion1.includes('B') || form_obj.skinquestion1.includes('C')) ? (survey_index=survey_index-2) : (survey_index =survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div> -->
                    <div class="page_next" @click="(form_obj.skinquestion3.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                  </div>
              </div>
              <!-- 第四题 -->
              <div class="survey_4 survey_item"  v-if="survey_index == 4">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_4">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                  
                  <div class="detail_title">你的皮肤是否有以下<strong>任何一种</strong>情况<br>皮肤纹理粗糙<br>浅表色斑<br>静态纹</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="radio" id="survey_4_a" value="A" v-model="form_obj.skinquestion4">
                      <label for="survey_4_a" :class="form_obj.skinquestion4 == 'A' ? 'now' : ''">是</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_4_b" value="B" v-model="form_obj.skinquestion4">
                      <label for="survey_4_b" :class="form_obj.skinquestion4 == 'B' ? 'now' : ''">否</label>
                    </li>
                    <!-- <li class="option_item">
                      <input type="radio" id="survey_4_c" value="C" v-model="form_obj.skinquestion4">
                      <label for="survey_4_c" :class="form_obj.skinquestion4 == 'C' ? 'now' : ''">静态纹</label>
                    </li> -->
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(current_ques--) && (survey_index=survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion4.length > 0) && (current_ques++,survey_index=survey_index+3)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>
                <!-- 第8题 -->
              <div class="survey_7 survey_item"  v-if="survey_index == 7">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_7">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                    <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                  
                  <div class="detail_title">你是否面部毛发较重</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="radio" id="survey_7_a" value="A" v-model="form_obj.skinquestion8">
                      <label for="survey_7_a" :class="form_obj.skinquestion8 == 'A' ? 'now' : ''">是</label>
                    </li>
                    <li class="option_item">
                      <input type="radio" id="survey_7_b" value="B" v-model="form_obj.skinquestion8">
                      <label for="survey_7_b" :class="form_obj.skinquestion8 == 'B' ? 'now' : ''">否</label>
                    </li>
                  
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(current_ques--) && (survey_index=survey_index-3)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion8.length > 0) && (current_ques++,survey_index=survey_index+1)"><span>下一题</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>

              <!-- 第9题 -->
              <div class="survey_8 survey_item"  v-if="survey_index == 8">
                <div class="survey_item_title">拯救毛孔粗大</div>
                <div class="survey_item_2nd_title">完成小问卷，为您提供更专业的护肤方案</div>
                <div class="survey_detail survey_detail_8">
                  <div class="pagination">
                    <span class="pagination_current">{{current_ques}}</span><span class="split_line">/</span>
                     <div class="ques_progress"><div class="progress_inner" :style="{'width':(current_ques/total_ques)*100+'%'}"></div></div>
                  </div>
                 
                  <div class="detail_title">你是否有这些皮肤问题/皮肤病(可多选)</div>
                  <ul class="detail_options">
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_a" value="A" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_a" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('A') > -1) ? 'now' : ''">严重痘痘</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_b" value="B" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_b" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('B') > -1) ? 'now' : ''">面部红斑/潮红</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_c" value="C" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_c" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('C') > -1) ? 'now' : ''">脂溢性皮炎</label>
                    </li>
                      <li class="option_item">
                      <input type="checkbox" id="survey_8_d" value="D" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_d" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('D') > -1) ? 'now' : ''">皮炎/湿疹</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_e" value="E" v-model="form_obj.skinquestion9" :disabled="form_obj.skinquestion9.indexOf('F') > -1" :checked="form_obj.skinquestion9.indexOf('F') > -1">
                      <label for="survey_8_e" :class="(form_obj.skinquestion9.indexOf('F') > -1) ? 'gray' :(form_obj.skinquestion9.indexOf('E') > -1) ? 'now' : ''">银屑病/牛皮癣</label>
                    </li>
                    <li class="option_item">
                      <input type="checkbox" id="survey_8_f" value="F">
                      <label for="survey_8_f" :class="(survey_9_selected) ? 'now' : ''" @click="changeinput()">都没有</label>
                    </li>
                  </ul>
                </div>
                <div class="switch_page">
                  <div class="page_prev" @click="(current_ques--) && (survey_index=survey_index-1)"><img src="../assets/images/arrow_survey_prev.svg" alt=""><span>上一题</span></div>
                  <div class="page_next" @click="(form_obj.skinquestion9.length > 0) && (show_survey_toaster=true)"><span>提交</span><img src="../assets/images/arrow_survey_next.svg" alt=""></div>
                </div>
              </div>
          </div>

        </div>
        <!-- 问卷区域end -->
       

   
		
		</div>
      <!-- 问卷提交弹窗 -->
      <div class="submit_toaster" v-if="show_survey_toaster">
        <div class="submit_toaster_inner">
          <img src="../assets/images/close_btn.svg" class="submit_toaster_close_btn" alt="" @click="show_survey_toaster=false">
          <div class="submit_toaster_title"></div>
          <div class="submit_toaster_main">
            <div class="submit_toaster_main_item"><div class="submit_toaster_main_item_title">基因结果</div><div class="submit_toaster_main_item_name">紧致能力</div></div>
            <div class="submit_toaster_main_item"><div class="submit_toaster_main_item_title">现状结果</div><div class="submit_toaster_main_item_name">肤质</div></div>
          </div>
           <p class="submit_toaster_text">如果你还没有现状检测结果<br>将以自述的肤质为依据</p>
           <div class="submit_toaster_btn"><span @click="show_survey_toaster=false;">返回问卷</span><span @click="(show_survey_toaster=false);($parent.trackLog((actParams = { query: $route.query, pageid:494 }),{is_access:true,reportEvent_page_id:494,reportEvent_page_name:'毛孔-提交问卷',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'}));submitForm()">确认提交</span></div>
        </div>
      </div>
 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
import { setTimeout } from 'timers';
var wx = require("weixin-js-sdk");
export default {
  name: "PoreSurvey",
  data() {
    return {
      isload: false,
      in_weapp: false, //是否在小程序
      show_survey_toaster:false,  //问卷提交弹窗
      poresurvey_data: null,
      show_survey: false,
      survey_index: 1, //问卷展示index
      has_pheno:false,
      pheno_judge:'',  //存在表型问卷数据  为待定或是否区分
      current_ques:1,    //页面标题题目
      total_ques:5,   //题目总数
      pheno_survey_skintype:"",   //表型问卷肤质结果 来判断毛孔问卷展示题目（有/无/是否待定/是否区分）
      form_obj: {
        skinquestion1: [],
        skinquestion2: [],
        skinquestion3: "",
        skinquestion4: "",
        skinquestion5: "",
        skinquestion6: "",
        skinquestion7: "",
        skinquestion8: "",
        skinquestion9: []
      },
      survey_9_selected:false,   //第九题是否选择了F
      survey_1_selected:false,   //第一题是否选择了C

      imgs: [
        require("../assets/images/1.png"),
        require("../assets/images/2.png"),
        require("../assets/images/3.png"),
        require("../assets/images/4.png")
      ],
      demopic: require("../assets/images/10.png")
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      vm.$parent.checkStatus();
    });
  },

  created() {
    console.log("poresurvey created", this);
    console.log(this.$route);
    //重填问卷 不初始化 isload重置为true  $route.query.redo=redo
    if(this.$route.query.redo == 'redo'){
      this.initPoreSurvey();  //重填问卷跟逻辑 与第一次填写问卷相同
    }else{
        this.initPoreSurvey();
    }
  
  },
  mounted() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
    changeinput:function(){   //第九题
      let that = this;
      that.survey_9_selected = !that.survey_9_selected;
      if(that.survey_9_selected){
        that.form_obj.skinquestion9 = ['F'];
      }else{
          that.form_obj.skinquestion9 = [];
      }
      console.log(this.form_obj.skinquestion9)
    },
    changeinput_ques1:function(){  //第一题
      let that = this;
      that.survey_1_selected = !that.survey_1_selected;
      if(that.survey_1_selected){
        that.form_obj.skinquestion1 = ['C'];
      }else{
          that.form_obj.skinquestion1 = [];
      }
      console.log(this.form_obj.skinquestion1)
    },
    inc(){
      this.current_ques++;
      // alert(this.current_ques);
    },
    getTotalQues:function(){  //获取总题目数
   
    if(this.has_pheno){  //有表型问卷
         //有表型 第一题单独a 或者b 1-2-345/678
         if(this.pheno_judge.includes('nodelay')){
           this.total_ques = 4;
         }else{
           if(this.form_obj.skinquestion2.includes('A') && this.form_obj.skinquestion2.includes('B')){
             this.total_ques = 6;
           }else{
             this.total_ques = 5;
           }
         }
    }else{   //无表型问卷
            if(this.form_obj.skinquestion1.includes('C') || this.form_obj.skinquestion1.includes('A') && this.form_obj.skinquestion1.includes('B')){
              this.total_ques = 5;
            }else{
              if(this.form_obj.skinquestion2.includes('A') && this.form_obj.skinquestion2.includes('B')){
                this.total_ques = 7;
              }else{
                this.total_ques = 6;
              }
              
            }
    }
    // alert(this.total_ques); 
    },
    submitForm: function() {
      // alert("submitting");
      let that = this;
      console.log('form_obj',that.form_obj);
      axios
        .post(
          "https://www.uniskin.com.cn/reportv2/index/report199_ex1/addPoreSurvey",
          that.form_obj
        )
        .then(res => {
          console.log(res);
          console.log(res.data.code);
          if (res.data.code == 0) {//提交成功
            //跳转至防晒详情页
            // that.$router.push("/poreskincareguide");
            return that.initSkincareGuide();  //请求方案接口 判断跳转分区或不分区
          } else {
            alert(res.data.msg);
          }
        })
        .catch(err => {
          alert(err);
        });
    },
      initSkincareGuide: function() {
      let that = this;
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getPoreSolution"
          )
          .then(json => {
            console.log(json);
            afterSkincareGuide(json);
           
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      
      function afterSkincareGuide(guidedata) {
        if (guidedata.code == 0) {
            if(guidedata.data.desc){
              that.$router.push({path:"/poreskincareguide",query:that.$route.query});
            }else{
              that.$router.push({path:"/poreguidearea",query:that.$route.query});
            }

        }
      }
    },
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    initPoreSurvey: function() {
      let that = this;
      var local_pore_survey = JSON.parse(
        localStorage.getItem("local_pore_survey")
      );
      if (local_pore_survey) {
        afterPoreSurvey(local_pore_survey);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getLastPhType"
          )
          .then(json => {
            console.log(json);
            afterPoreSurvey(json);
            // localStorage.setItem("local_pore_survey",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterPoreSurvey(poresurvey_data) {
        if (poresurvey_data.code == 0) {
          that.isload = true;
          that.poresurvey_data = poresurvey_data.data;
          //根据接口返回 判断是否存在表型数据 -> skintype 为空 则没有表型
          //存在表型时 判断展示题目
          if(poresurvey_data.data.skin_type){   //data = '' 时没有表型问卷
            that.has_pheno = true;
          }else{
            that.has_pheno =false;
          }
          if(poresurvey_data.data.head_type && poresurvey_data.data.face_type){
            let t_result = poresurvey_data.data.head_type;   //T区结果 
            let v_result = poresurvey_data.data.face_type;  //脸颊结果
            if((t_result.includes("油") || t_result.includes("偏油")) && (v_result.includes("中") || v_result.includes("偏干") || v_result.includes("干"))){
              that.pheno_judge = 'delay';  //待定
              that.survey_index = 2;
            }else if((t_result.includes("中") || t_result.includes("偏干") || t_result.includes("干")) && (v_result.includes("油") || v_result.includes("偏油"))){
              that.pheno_judge = 'delay';  //待定
              that.survey_index = 2;
            }else if((t_result.includes("油") || t_result.includes("偏油")) && (v_result.includes("油") || v_result.includes("偏油"))){
              that.pheno_judge = 'nodelay';  //不需要区分
              that.survey_index = 3;
            }else if((t_result.includes("中") || t_result.includes("偏干") || t_result.includes("干")) && (v_result.includes("中") || v_result.includes("偏干") || v_result.includes("干"))){
              that.pheno_judge = 'nodelay';  //不需要区分
              that.survey_index =3;
            }
          }
        }else if(poresurvey_data.code == 100){
          alert("请先登录");
          location.href = "https://www.uniskin.com.cn/mall/member/account/login";
        }
      }
    },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
// 问卷提交弹窗
.submit_toaster{
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background:rgba(0,0,0,0.3);
  .submit_toaster_inner{
    box-sizing:border-box;
    .border-radius(15/50rem);
    .shadow;
    background:#fff;
    position:absolute;
    top:50%;
    left:50%;
    -webkit-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
    width:596/50rem;
    padding:76/50rem 0 0;
    text-align:center;
  }
  .submit_toaster_close_btn{
    position:absolute;
    width:30/50rem;
    height:30/50rem;
    right:30/50rem;
    top:30/50rem;
  }
  .submit_toaster_title{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-center;
    &::before{
      content:"方案还将融入你的检测数据";
      display:block;
      .align-self_center;
      border-bottom:1px solid @font-c-detail;
      font-size:30/50rem;
      line-height:1.1em;
      font-weight:bold;
      color:@font-c-detail;
    }
  }
  .submit_toaster_main{
    padding:47/50rem 78/50rem 0;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    .submit_toaster_main_item{
      width:202/50rem;
      padding:27/50rem 0 34/50rem;
      .border-radius(14/50rem);
      // border:1px solid @font-c-detail;
      .border-1px;
      .submit_toaster_main_item_title{
        font-size:22/50rem;
        line-height:1em;
        color:@font-c-detail;
        padding-bottom:14/50rem;
        font-weight:bold;
      }
      .submit_toaster_main_item_name{
        font-size:26/50rem;
        line-height:1em;
        color:@font-c-detail;
        font-weight:bold;
      }
    }
  }
  .submit_toaster_text{
    padding:18/50rem 0 57/50rem;
    text-align:center;
    font-size:24/50rem;
    line-height:28/50rem;
    color:@font-c-6;
  }
  .submit_toaster_btn{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    span{
      box-sizing:border-box;
      width:50%;
      padding:30/50rem 0;
      text-align:center;
      font-size:30/50rem;
      line-height:1em;
      font-weight:bold;
      &:first-child{
        .border-radius-side(0,0,0,15/50rem);
        background-color:#ffdddc;
        color:@font-c-detail;
      }
      &:last-child{
        .border-radius-side(0,0,15/50rem,0);
        background:@font-c-detail;
        color:#fff;
      }
    }
  }
}
.pore_survey_inner {
  background: @bg_c_m;
  padding: 54/50rem 0 0;
}
.hide_btn{
  opacity:0;
  z-index:-999;
}
.back_btn {
  position: fixed;
  top: 0.6rem;
  left: 0;
  width: 2.36rem;
  height: 1.08rem;
  z-index: 888;
}
.survey_entry {
  position:fixed;
  box-sizing:border-box;
  width:100%;
  height:100%;
  top:0;
  left:0;
  padding: 54/50rem 30/50rem 283/50rem;
  background:@bg_c_m;
}
.pore_survey_title {
  padding-bottom: 71/50rem;
  font-size: 44/50rem;
  font-weight: bold;
  line-height: 1em;
  text-align: center;
  color: @font-c-3;
}
.pore_qa {
  box-sizing: border-box;
  .shadow;
  .border-radius(14/50rem);
  background: @bg_c_l;
  padding: 55/50rem 30/50rem 29/50rem;
  .pore_qa_title {
    padding-bottom: 34/50rem;
    font-size: 28/50rem;
    font-weight: bold;
    line-height: 1em;
    color: @font-c-3;
  }
  .pore_qa_2nd_title {
    position: relative;
    padding-left: 21/50rem;
    font-size: 28/50rem;
    line-height: 1em;
    color: @font-c-detail;
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%) scale(0.5);
      width: 10px;
      height: 10px;
      .border-radius(50%);
      background: @font-c-detail;
    }
  }
  .pore_qa_info {
    padding: 10/50rem 0 26/50rem 21/50rem;
    font-size: 24/50rem;
    line-height: 32/50rem;
    color: @font-c-6;
  }
}
.qa_sub_text {
  padding: 34/50rem 0 164/50rem;
  font-size: 28/50rem;
  line-height: 34/50rem;
  color: @font-c-3;
}
.pore_start_btn {
  box-sizing: border-box;
  margin: 0 auto;
  text-align: center;
  width: 600/50rem;
  height: 88/50rem;
  line-height: 88/50rem;
  .border-radius(14/50rem);
  font-size: 34/50rem;
  font-weight: bold;
  color: @font-c-f;
  background: @font-c-detail;
}
.survey_container {
  background: @bg_c_m;
}
.survey_item {
  padding: 54/50rem 30/50rem 147/50rem;
  box-sizing: border-box;
  background: @bg_c_m;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-overflow-y: scroll;
  overflow-y: scroll;
}
.survey_item_title {
  text-align: center;
  font-size: 44/50rem;
  font-weight: bold;
  line-height: 1em;
  color: @font-c-3;
}
.survey_item_2nd_title {
  padding: 16/50rem 0 49/50rem;
  text-align: center;
  font-size: 28/50rem;
  line-height: 1em;
  color: @font-c-6;
}
.survey_detail {
  overflow: hidden;
  -webkit-overflow-y:scroll;
  overflow-y:scroll;
  padding: 37/50rem 35/50rem 0;
  background: @bg_c_l;
  .shadow;
  .border-radius(14/50rem);
  box-sizing: border-box;
  width: 100%;
  height: 868/50rem;
  .pagination {
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    .pagination_total,
    .pagination_current,
    .split_line {
      .flex_0;
      .align-self_flex-end;
    }
    .pagination_current {
      font-size: 60/50rem;
      line-height: 1em;
      font-weight: bold;
      color: @font-c-detail;
    }
    .split_line{
      font-size:60/50rem;
      line-height:1em;
      font-weight:lighter;
      color: @font-c-detail;
      -webkit-transform:scaleX(0.5);
      transform:scaleX(0.5);
    }
    .pagination_total {
      display:none;
      font-size: 28/50rem;
      line-height: 1em;
      font-weight: bold;
      color: @font-c-detail;
    }
  }
  .detail_title {
    padding: 20/50rem 0 0;
    font-size: 34/50rem;
    line-height: 45/50rem;
    strong{
      color:@font-c-detail;
      font-weight:bold;
    }
  }
  .detail_2nd_title {
    font-size: 28/50rem;
    line-height: 1em;
    color: @font-c-3;
    padding-top: 12/50rem;
  }
}

.option_item input {
  position: absolute;
  top: 0;
  left: -100rem;
  opacity: 0;
}
.option_item label {
  position: relative;
  padding-left: 32/50rem;
  font-size: 34/50rem;
  line-height: 1em;
  color: @font-c-3;
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 22/50rem;
    height: 22/50rem;
    .border-radius(50%);
    border: 1px solid @font-c-detail;
    background: transparent;
  }
}
.option_item label.gray {
  color: @font-c-9;
}
.option_item label.now {
  img{
    border:2px solid @font-c-detail;
  }
}
.option_item label.now::before {
  border:1px solid #f05956;
  background: @font-c-detail;
}
.switch_page {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30/50rem;
  bottom: 63/50rem;
  left: 0;
  .display_flex;
  .flex-wrap_nowrap;
  .justify-content_flex-justify;
  .page_prev {
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    span {
      font-size: 28/50rem;
      line-height: 1em;
      color: @font-c-3;
      padding-left: 20/50rem;
      .align-self_center;
    }
    img {
      .align-self_center;
      width: 84/50rem;
    }
  }
  .page_next {
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-end;
    span {
      font-size: 28/50rem;
      line-height: 1em;
      color: @font-c-3;
      padding-right: 20/50rem;
      .align-self_center;
    }
    img {
      .align-self_center;
      width: 84/50rem;
    }
  }
}

//第一题 第二题
.survey_1 .switch_page {
  .justify-content_flex-end;
}
.survey_container_pheno_delay .survey_2 .switch_page,
.survey_container_pheno_nodelay .survey_3 .switch_page{
  .justify-content_flex-end;
}
.survey_detail_1 .detail_options,
.survey_detail_2 .detail_options {
  position: relative;
  margin: 87/50rem auto 0;
  width: 369/50rem;
  height: 294/50rem;
  background: url("../assets/images/pore_survey_face.png") no-repeat 0 0;
  background-size: 100%;
  .option_item {
    position: absolute;
    transform: translateY(-20%);
  }
  .option_item:nth-child(1) {
    right: -105/50rem;
    top: 107/50rem;
  }
  .option_item:nth-child(2) {
    left: -105/50rem;
    top: 203/50rem;
  }
  .option_item:nth-child(3) {
    left: 139/50rem;
    bottom: -90/50rem;
  }
}

//第三题
.survey_detail_3 .detail_options {
  padding-top: 10/50rem;
  .display_flex;
  .flex-wrap_wrap;
  .justify-content_flex-justify;
  .option_item {
    .display_flex;
    .flex-direction_column;
    .justify-content_flex-justify;
    box-sizing: border-box;
    height: 312/50rem;
    padding-top: 54/50rem;
    width: 47%;
    label {
      box-sizing: border-box;
      display: block;
      font-size: 24/50rem;
      line-height: 28/50rem;
      &::before {
        top: 0;
        transform: translateY(0);
      }
      .display_flex;
      .flex-direction_column;
      .flex-wrap_nowrap;
      .justify-content_flex-justify;
      height:100%;
      span{
        .flex_0;
      }
      img{
        .flex_0;
        box-sizing:border-box;
        margin: 10/50rem 0 0 0rem;
        width: 160/50rem;
        .border-radius(14/50rem);
      }
    }
    // img {
    //   box-sizing: border-box;
    //   display: block;
    //   margin: 10/50rem 0 0 32/50rem;
    //   width: 160/50rem;
    // }
  }
}
//第四题
.survey_detail_4 .detail_options {
  padding-top: 64/50rem;
  .option_item {
    margin-bottom: 36/50rem;
    label {
      padding-left: 44/50rem;
    }
  }
}
//第五题
.survey_5.survey_item {
  position: relative;
  .survey_detail {
    height: auto;
  }
}
.survey_detail_5 .detail_options {
  padding-top: 10/50rem;
  .display_flex;
  .flex-wrap_wrap;
  .justify-content_flex-justify;
  .option_item {
    .display_flex;
    .flex-direction_column;
    .justify-content_flex-justify;
    box-sizing: border-box;
    height: 312/50rem;
    padding-top: 54/50rem;
    width: 47%;
    label {
      box-sizing: border-box;
      display: block;
      font-size: 24/50rem;
      line-height: 28/50rem;
      &::before {
        top: 0;
        transform: translateY(0);
      }
      height:100%;
      .display_flex;
      .flex-direction_column;
      .flex-wrap_nowrap;
      .justify-content_flex-justify;
      span{
        .flex_0;
      }
      img{
        .flex_0;
        box-sizing: border-box;
        .border-radius(14/50rem);
        margin: 10/50rem 0 0 0rem;
        width: 160/50rem;
      }
    }
    // img {
    //   box-sizing: border-box;
    //   display: block;
    //   margin: 10/50rem 0 0 32/50rem;
    //   width: 160/50rem;
    // }
  }
}
.survey_detail_5 .detail_options_5 {
  padding-bottom: 53/50rem;
  padding-top: 50/50rem;
  .border-bottom-gray;
  &::before {
    content: "额头区域";
    display: block;
    position: absolute;
    top: 53/50rem;
    left: 0;
    font-size: 28/50rem;
    font-weight: bold;
    color: @font-c-3;
  }
}
.survey_detail_5 .detail_options_5_1 {
  padding-bottom: 53/50rem;
  padding-top: 40/50rem;
  .border-bottom-gray;
  &::before {
    content: "脸颊区域";
    display: block;
    position: absolute;
    top: 45/50rem;
    left: 0;
    font-size: 28/50rem;
    font-weight: bold;
    color: @font-c-3;
  }
}
//第六题
.survey_detail_6 .detail_options {
  padding-top: 70/50rem;
  .option_item {
    margin-bottom: 36/50rem;
    label {
      padding-left: 44/50rem;
    }
  }
}

//第七题
.survey_detail_7 .detail_options {
  padding-top: 74/50rem;
  .option_item {
    margin-bottom: 36/50rem;
    label {
      padding-left: 44/50rem;
    }
  }
}

//第八题
.survey_detail_8 .detail_options {
  padding-top: 60/50rem;
  .option_item {
    margin-bottom: 30/50rem;
    label {
      padding-left: 44/50rem;
    }
  }
}
//进度条
.ques_progress{
  .border-radius(10/50rem);
  margin:15/50rem 0 15/50rem 25/50rem;
  height:15/50rem;
  width:70%;
  background:#ffdddc;
  .display_flex;
  .flex-wrap_nowrap;
  .justify-content_flex-start;
  .progress_inner{
    .border-radius(10/50rem);
    height:100%;
    width:20%;
    background:@font-c-detail;
  }
}
</style>
